import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M11.84 11.29a2 2 0 00-2.74 0l-6.47 6.12A2 2 0 002 18.86V28a2 2 0 002 2h13a2 2 0 002-2v-9.13a2 2 0 00-.63-1.46zM17 28H4v-9.14l6.47-6.11L17 18.87z"/><path d="M7.71 21.29a1 1 0 00-1.42 1.42l2 2A1 1 0 009 25a1 1 0 00.62-.22l5-4a1 1 0 10-1.24-1.56l-4.31 3.44zM25.88 8.22l-1.81 1.44-.36-.37a1 1 0 00-1.42 1.42l1 1A1 1 0 0024 12a1 1 0 00.62-.22l2.5-2a1 1 0 10-1.24-1.56z"/><path d="M29.35 6.17l-4.18-3.9a1 1 0 00-1.34 0l-4.18 3.9A2.1 2.1 0 0019 7.69V14a1 1 0 001 1h9a1 1 0 001-1V7.69a2.1 2.1 0 00-.65-1.52zM28 13h-7V7.69v-.06l3.5-3.25L28 7.63v.06z"/>';
export var ComparableHomesOutlineSVG = function ComparableHomesOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ComparableHomesOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ComparableHomesOutlineSVG);